import { render, staticRenderFns } from "./CommonAlert.vue?vue&type=template&id=0c3ef5d7&scoped=true&"
import script from "./CommonAlert.vue?vue&type=script&lang=ts&"
export * from "./CommonAlert.vue?vue&type=script&lang=ts&"
import style0 from "./CommonAlert.vue?vue&type=style&index=0&id=0c3ef5d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ef5d7",
  null
  
)

export default component.exports